import {getPublicProperty} from '@netx/core-app-next/utils/getPublicProperty';
import {isBrandPortal} from '@netx/core-cms-next/utils/isBrandPortal';
import {UserPref} from '../constants';
import {useCurrentUser} from '../store/currentUser';

export const isPublicUser = (userLogin?: string) => {
	return (
		isBrandPortal() &&
		getPublicProperty(UserPref.PUBLIC_USER_LOGIN) ===
			(userLogin ?? useCurrentUser.getState().user.login)
	);
};

export default isPublicUser;
